import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';

@Injectable({
  providedIn: 'root'
})
export class TestPingService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public pingTest(): Observable<ReturnStruct> {

    let uri = `TestPing`;

    return this.httpClient.get<ReturnStruct>(environment.urlApiTestNetwork + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}